import React from 'react';
import PropTypes from 'prop-types';
import { Spacer, Visible, ValidatedTextInputV2 } from '@tfecom-thermofisher/react-komodo-design';

import { Message } from 'src/core/components';
import {
  REMAINDER_CHECKED,
  REMAINDER_PLATE_TYPE,
  REMAINDER_TREATMENT,
  REMAINDER_TREATMENT_OPTIONS,
  REMAINDER_PLATE_TYPE_OPTIONS,
  MORE_INFO_REMAINDERS_LINK,
  REMAINDER_VOLUME,
  SECOND_PRIORITY_COUNTRIES
} from 'src/constants/forms';
import { positiveNumberValidator } from 'src/validators';
import { SectionTitle, DataSelector, Toggle } from 'src/components';
import generalMessages from 'src/messages';
import { getCountryCode } from 'src/utils';

// eslint-disable-next-line max-len
const RemaindersComponent = ({
  formData = {},
  onChangeData,
  onBlurVolume
}) => {
  const remaindersVisible = formData[REMAINDER_CHECKED]?.value || false;

  return (
    <>
      <SectionTitle title={generalMessages.remainders} allFieldsRequired />
      <Spacer bottom="22" />

      <Toggle
        {...{
          title: generalMessages.remainders,
          checked: formData[REMAINDER_CHECKED]?.value,
          onToggle: (checked) => onChangeData(checked, REMAINDER_CHECKED, true),
          moreInfoLinkRemainders: MORE_INFO_REMAINDERS_LINK,
        }}
      />

      <Visible when={remaindersVisible}>
        <Spacer top="32" />
        <DataSelector
          {...{
            title: generalMessages.remainderTreatment,
            config: REMAINDER_TREATMENT_OPTIONS,
            selectedValue: formData[REMAINDER_TREATMENT]?.value,
            onSelect: (value) => onChangeData(value, REMAINDER_TREATMENT, true),
          }}
        />

        <Spacer top="32" />
        <DataSelector
          {...{
            title: generalMessages.remainderPlateType,
            config: REMAINDER_PLATE_TYPE_OPTIONS,
            selectedValue: formData[REMAINDER_PLATE_TYPE]?.value,
            onSelect: (value) => onChangeData(value, REMAINDER_PLATE_TYPE, true),
          }}
        />
        <Visible when={!SECOND_PRIORITY_COUNTRIES.includes(getCountryCode())}>
          <ValidatedTextInputV2
            data-testid="remainder-volume"
            label={<Message message={generalMessages.remainderVolume} />}
            showOnlyOneError
            onBlur={onBlurVolume}
            value={formData[REMAINDER_VOLUME]?.value}
            validators={[
              positiveNumberValidator(
                generalMessages.numericalRemainderVolumeError
              )
            ]}
            onChange={
              (value, e, canValidate, isValid) => onChangeData(value, REMAINDER_VOLUME, isValid)
            }
          />
        </Visible>
      </Visible>
    </>
  );
};

RemaindersComponent.propTypes = {
  formData: PropTypes.object,
  onChangeData: PropTypes.func.isRequired,
  onBlurVolume: PropTypes.func.isRequired,
};

export default RemaindersComponent;
